import {createAction} from '@reduxjs/toolkit'
import {
  DeleteAdminPayload,
  GeneralFormParams,
  Roles,
  UpdateInvitedAdminsPayload,
} from 'interfaces'

const inviteAdmins = createAction<GeneralFormParams>('inviteAdmins')
const inviteAdminsFailure = createAction<string>('inviteAdminsFailure')
const inviteAdminsSuccess = createAction('invitedAdminsSuccess')

const updateInvitedAdmins = createAction<UpdateInvitedAdminsPayload>(
  'updateInvitedAdmins',
)
const updateInvitedAdminsFailure = createAction<string>(
  'updateInvitedAdminsFailure',
)
const updateInvitedAdminsSuccess = createAction('updateInvitedAdminsSuccess')

const deleteAdmin = createAction<DeleteAdminPayload>('deleteAdmin')
const deleteAdminFailure = createAction<string>('deleteAdminFailure')
const deleteAdminSuccess = createAction('deleteAdminSuccess')

const getRoles = createAction('getRoles')
const getRolesFailure = createAction<string>('getRolesFailure')
const getRolesSuccess = createAction<Roles[]>('getRolesSuccess')

export {
  inviteAdmins,
  inviteAdminsFailure,
  inviteAdminsSuccess,
  deleteAdmin,
  deleteAdminFailure,
  deleteAdminSuccess,
  updateInvitedAdmins,
  updateInvitedAdminsFailure,
  updateInvitedAdminsSuccess,
  getRoles,
  getRolesFailure,
  getRolesSuccess,
}
